import { format } from 'date-fns'

/**
 * @param dateString - '2020-05-05T15:22:08.000Z'
 * @returns - 'July 31st, 2020'
 * */
const prettifyOnWhatDay = (dateOrString: string | Date) => {
  const date = typeof dateOrString === 'string' ? new Date(dateOrString) : dateOrString
  return format(date, 'MMMM do, yyyy')
}

export default prettifyOnWhatDay
